import { render } from "./QHLSDashboard.vue?vue&type=template&id=2ff268c9&scoped=true"
import script from "./QHLSDashboard.vue?vue&type=script&lang=js"
export * from "./QHLSDashboard.vue?vue&type=script&lang=js"

import "./QHLSDashboard.vue?vue&type=style&index=0&id=2ff268c9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff268c9"]])

export default __exports__